<template>
    <div class="background" ref="OurBusiness">
        <dialogConsultancy :visible="popupVisible"  @close="closePopup('consultancy')"></dialogConsultancy>
        <dialogShooting :visible="popupVisibleShooting"  @close="closePopup('shooting')"></dialogShooting>
        <div class="layer">
            <ul class="card">
                <li id="live" @click="pageOpen('live')">
                    <img src="../assets/live.png" class="cardimage"/>
                    <p class="title">LIVE<br/>ENTERTAINMENT</p>
                    <p class="info">Band shows/Instruments/DJ<br/>
                        Dance Shows/MC/Models<br/>
                        Magicians/Clowns/Traditions</p>
                </li>
                <li id="event" @click="pageOpen('eventList')">
                    <img src="../assets/event.png" class="cardimage"/>
                    <p class="title">EVENT<br/>PRODUCTION</p>
                    <p class="info">Creative Concept <br/>
                        Artist Mgmt./Event Execution <br/>
                        Live Entertainment/AV Making</p>
                </li>
                <li id="consultancy" @click="showPopup('consultancy')" >
                    <img src="../assets/consultancy.png" class="cardimage"/>
                    <p class="title">BUSSINESS<br/>CONSULTANCY</p>
                    <p class="info">New Outlets Opening <br/>
                        Bar/Restaurant Biz Consultancy <br/>
                        Market Comm./Business Op.</p>
                </li>
                <li id="shooting" @click="showPopup('shooting')" >
                    <img src="../assets/shooting.png" class="cardimage"/>
                    <p class="title">COMMERTIAL<br/>SHOOTING</p>
                    <p class="info">Social Media Content<br/>
                        Product/Fashion/Party Shooting<br/>
                        Certified Photographer</p>
                </li>
            </ul>
        </div> 
        
    </div>
  </template>
  
  <script>
  import dialogConsultancy from "./ConsultancyPage.vue"
  import dialogShooting from "./ShootingPage.vue"

  export default {
    components:{
        dialogConsultancy,
        dialogShooting,
    },
    props: {
        selected: String,
    },
    data() {
      return {
        popupVisible: false,
        popupVisibleShooting: false,
        popupContent: '这是一个弹窗'
      };
    },
    methods: {
        pageOpen(id) {
            this.$emit('navigate', id); // 发出 `navigate` 事件，传递点击的id
            console.log("检测到点击",id)
        },
        handleClick(data){
          this.Visiable=true;
          this.$nextTick(()=>{
          //这里的dialog与上面dialog-component组件里面的ref属性值是一致的
          //init调用的是dialog-component组件里面的init方法
          //data是传递给弹窗页面的值
            this.$refs.dialog.init(data);
          })
        },
        showPopup(id) {
            if (id == "consultancy"){
                this.popupVisible = true;
                console.log(id,this.popupVisible)
            }
            else if (id == "shooting"){
                this.popupVisibleShooting = true;
            }
            
        },
        closePopup(id) {
            if (id == "consultancy"){
                this.popupVisible = false;
            }
            else if (id == "shooting"){
                this.popupVisibleShooting = false;
            }
            
        },
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    
    .background{
        height: auto;
        width: 100vw;
        background: url(../assets/background.png) repeat center center;
        background-size: cover;
        z-index: -1; /* 确保背景位于内容之下 */
        display: flex;
        align-items:center;
    }
    .layer{
        background-color: rgba(0,0,0,0.5);
        height: 100vh;
        width: 100vw;
        display: flex;
        align-items:center;
        z-index: 1;
    }
    .title{
        color: white;
        font-family: Futura, Helvetica, Arial, sans-serif;
        font-size: 1.5rem;
        line-height: 2rem;
        margin: 2rem;
    }
    .info{
        color: white;
        font-family: Futura, Helvetica, Arial, sans-serif;
        line-height: 2rem;
        font-size: 1rem;
    }
    .card{
        list-style: none;
        display: flex;
        align-items: center;
        position: relative;
        margin: auto;
        text-align: center;
    }
    .card li{
        width: calc((72vw - 16px * 5)/4);
        margin: 8px;
    }
    .cardimage{
        width: calc((72vw - 16px * 5)/4);
    }
    @media (max-width: 768px) {
        .background{
            height: auto;
            width: 100vw;
            background: url(../assets/background.png) repeat center center;
            background-size:auto;
            z-index: -1; /* 确保背景位于内容之下 */
            display: flex;
            align-items:center;
        }
        .layer{
            background-color: rgba(0,0,0,0.5);
            height: auto;
            width: 100vw;
            display: flex;
            align-items:center;
            z-index: 1;
        }
        .card{
            list-style: none;
            display: flex;
            height: auto;
            flex-direction: column;

        }
        .card li{
            width: 70vw;
            margin: 32px;
            
        }
        .cardimage{
            width: 70vw;
            box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5);
        }
        
    }
  </style>
  